// styled
import { TableCellWrapper } from './style';
// type
import type { ICell } from './type';
// options
import Category from './Category';
import Id from './Id';
import Profile from './Profile';

type CellType = 'common' | 'number' | 'center';

export interface ICommonCell extends ICell {
	cell_type?: CellType;
}

const TableCell = ({
	cell_type = 'common',
	_width,
	children,
	_margin,
	_padding,
	_onClick,
}: ICommonCell) => {
	return (
		<TableCellWrapper
			_width={_width}
			flex={cell_type === 'number' ? 'end' : cell_type === 'common' ? 'start' : 'center'}
			_margin={_margin}
			_padding={_padding ?? (cell_type === 'common' ? '0 0 0 16px' : '0 16px 0 0')}
			onClick={_onClick}
		>
			{typeof children === 'string' ? <p>{children}</p> : children}
		</TableCellWrapper>
	);
};

TableCell.Profile = Profile;
TableCell.Id = Id;
TableCell.Category = Category;

export default TableCell;
